<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-4">
      <historial :ordinario="false" />
      <nuevo :ordinario="false" />
    </div>
  </div>
</template>

<script>
import historial from "../../components/requisiciones/HistorialSolicitud.vue";
import nuevo from "../../components/requisiciones/NuevaSolicitud.vue";

export default {
  name: "BandejaOrdinario",
  components: {
    historial,
    nuevo,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>